import { Factory, Palette, Compass, HeartHandshake, Share2 } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const CREW = [
  { icon: Factory, title: "Our production team", body: "The great team in our Nova Scotia facility who make every batch of Swole Bears.", color: "#FFB21A", span: "lg:col-span-7" },
  { icon: Palette, title: "Package design helpers", body: "The people who helped turn my rough ideas into the bags you see on shelves today.", color: "#FF6F91", span: "lg:col-span-5" },
  { icon: Compass, title: "Mentors & advisors", body: "The people who help me think bigger and make better decisions as Swole Bears grows.", color: "#7CC4FF", span: "lg:col-span-4" },
  { icon: HeartHandshake, title: "Everyone rooting me on", body: "Family, friends, store owners and customers who believed in a kid with a crazy idea.", color: "#7BD88F", span: "lg:col-span-4" },
  { icon: Share2, title: "You, on social media", body: "Every share, comment and \"you have to try these\" to a friend. That's how a small brand gets found.", color: "#FF5A5F", span: "lg:col-span-4" },
];

const Card = ({ c, i }) => (
  <Reveal delay={i * 0.06} data-testid={`team-card-${i}`} className={`${c.span} rounded-[28px] bg-white border border-[#1B1530]/10 p-6 sm:p-7 transition-transform duration-300 hover:-translate-y-1`}>
    <span className="grid h-12 w-12 place-items-center rounded-2xl" style={{ background: `${c.color}33` }}>
      <c.icon className="h-6 w-6" style={{ color: "#1B1530" }} />
    </span>
    <h3 className="font-display text-2xl sm:text-3xl mt-5 leading-none">{c.title}</h3>
    <p className="mt-3 text-base text-[#1B1530]/80 leading-relaxed">{c.body}</p>
  </Reveal>
);

export const TeamThanks = () => (
  <section id="team" data-testid="team-thanks-section" className="py-20 lg:py-28">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-12">
        <Reveal className="lg:col-span-7">
          <Eyebrow className="text-[#FF5A5F] mb-4">The team behind the bears</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">It started with just me.<br />It's not just me anymore.</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5 self-end">
          <p className="text-base sm:text-lg text-[#1B1530]/80 leading-relaxed">
            In the beginning I did absolutely everything myself. Today Swole Bears is built by a whole team of people, and I'm so grateful for every one of them.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        {CREW.map((c, i) => <Card key={c.title} c={c} i={i} />)}
      </div>
      <Reveal data-testid="team-thank-you-note" className="mt-10 rounded-[32px] bg-[#1B1530] text-white p-8 sm:p-12 grid lg:grid-cols-12 gap-6 items-center">
        <p className="lg:col-span-9 font-display text-2xl sm:text-3xl lg:text-4xl leading-tight">
          To everyone who has helped on this journey, big or small: thank you. Every batch, every bag and every store we're in has your fingerprints on it.
        </p>
        <p className="lg:col-span-3 lg:text-right text-sm font-bold uppercase tracking-[0.2em] text-[#FFB21A]">Rory Fox<br /><span className="text-zinc-300 normal-case tracking-normal font-semibold">Founder</span></p>
      </Reveal>
    </div>
  </section>
);
